import React, { useState } from 'react';
import Modal from '../UI/Modal';
import Button from '../UI/Button';

const templates = [
	{ id: 'modern', name: 'Modern', premium: false },
	{ id: 'professional', name: 'Professional', premium: false },
	{ id: 'creative', name: 'Creative', premium: true },
	{ id: 'minimal', name: 'Minimal', premium: true }
];

export default function TemplateSelector({ selectedTemplate, onSelectTemplate, onPremiumConfirm, userCredits = 0 }) {
	const [confirm, setConfirm] = useState(null);

	function select(id, premium) {
		if (premium) {
			setConfirm({ id });
			return;
		}
		onSelectTemplate?.(id);
	}

	async function handleConfirm() {
		if (!confirm) return;
		onSelectTemplate?.(confirm.id);
		// Optionally notify parent to deduct credits
		onPremiumConfirm?.(confirm.id);
		setConfirm(null);
	}

	return (
		<div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
			{templates.map((t) => (
				<button
					type="button"
					key={t.id}
					onClick={() => select(t.id, t.premium)}
					className={`relative rounded-lg border-2 p-4 text-left ${
						selectedTemplate === t.id ? 'border-primary-600' : 'border-gray-200 hover:border-primary-300'
					}`}
				>
					{t.premium && (
						<span className="absolute top-2 right-2 text-xs bg-primary-600 text-white px-2 py-0.5 rounded">Premium</span>
					)}
					<div className="h-24 bg-gray-100 rounded mb-3" />
					<div className="font-medium">{t.name}</div>
					{t.premium && <div className="text-xs text-gray-500">Costs 2 credits (you have {userCredits})</div>}
				</button>
			))}
			<Modal isOpen={!!confirm} onClose={() => setConfirm(null)} title="Use premium template?">
				<p className="text-sm text-gray-600">Using this template costs 2 credits. Continue?</p>
				<div className="mt-4 flex justify-end gap-2">
					<Button variant="ghost" onClick={() => setConfirm(null)}>
						Cancel
					</Button>
					<Button onClick={handleConfirm}>Confirm</Button>
				</div>
			</Modal>
		</div>
	);
}


